import { render } from "./UserContact.vue?vue&type=template&id=2ddd37fa&scoped=true&ts=true"
import script from "./UserContact.vue?vue&type=script&lang=ts"
export * from "./UserContact.vue?vue&type=script&lang=ts"

import "./UserContact.vue?vue&type=style&index=0&id=2ddd37fa&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddd37fa"]])

export default __exports__